module.exports = __webpack_public_path__ + "static/media/p2.3f8d9077.svg";